import React from "react"
import styled from "styled-components"
import Page3Barchart1 from "./Page3Barchart1"
import Page3Barchart2 from "./Page3Barchart2"
import Page3Barchart3 from "./Page3Barchart3"
import Page3Barchart4 from "./Page3Barchart4"

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`

const PageArrowWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 136px;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 48px;
  align-self: stretch;
`

const Grid1 = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  align-self: stretch;
`

const Grid2 = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 80px;
  align-self: stretch;
`

const Frame = styled.div`
  display: flex;
  width: 520px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: var(--base-gray90, #404040);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const Legend = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const ChartWrapper = styled.div`
  display: flex;
  width: 520px;
  height: 256px;
  padding: 16px;
  justify-content: center;
  align-items: center;

  border-radius: 16px;
  border: 1px solid var(--base-gray40, #bfbfbf);
  background: var(--base-white100, #fff);
`

const BottomLegend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

interface Props {
  대전Data: any
  보령Data: any
  여수Data: any
  정읍Data?: any
  rate?: any
}

const Page3 = (props: Props) => {
  const { 대전Data, 보령Data, 여수Data, 정읍Data, rate } = props

  return (
    <Wrapper>
      <PageArrowWrapper></PageArrowWrapper>
      <Content>
        <Grid1>
          <Frame>
            <ChartHeader>
              에너지 자립율 변화 (전/후)
              <Legend>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#BFBFBF"
                      stroke-width="4"
                    />
                  </svg>
                  거래 전
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#2669DE"
                      stroke-width="4"
                    />
                  </svg>
                  거래 후
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#B89EFA"
                      stroke-width="4"
                    />
                  </svg>
                  목표자립률
                </LegendItem>
              </Legend>
            </ChartHeader>
            <ChartWrapper>
              {정읍Data && 대전Data && 보령Data && 여수Data ? (
                <Page3Barchart1
                  data={{
                    정읍Data: 정읍Data,
                    대전Data: 대전Data,
                    보령Data: 보령Data,
                    여수Data: 여수Data,
                  }}
                  height="100%"
                  width="100%"
                  annotations={rate}
                />
              ) : (
                <p>Loading...</p>
              )}
            </ChartWrapper>
          </Frame>
          <Frame>
            <ChartHeader>
              전력 판매 및 구매량
              <Legend>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#4282EF"
                      stroke-width="4"
                    />
                  </svg>
                  판매량
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#B89EFA"
                      stroke-width="4"
                    />
                  </svg>
                  구매량
                </LegendItem>
              </Legend>
            </ChartHeader>
            <ChartWrapper>
              {정읍Data && 대전Data && 보령Data && 여수Data ? (
                <Page3Barchart2
                  data={{
                    정읍Data: 정읍Data,
                    대전Data: 대전Data,
                    보령Data: 보령Data,
                    여수Data: 여수Data,
                  }}
                  height="100%"
                  width="100%"
                />
              ) : (
                <p>Loading...</p>
              )}
            </ChartWrapper>
          </Frame>
        </Grid1>
        <Grid2>
          <Frame>
            <ChartHeader>
              마을 간 전력 판매/구매 금액
              <Legend>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#4282EF"
                      stroke-width="4"
                    />
                  </svg>
                  판매금액
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7"
                      r="5"
                      stroke="#B89EFA"
                      stroke-width="4"
                    />
                  </svg>
                  구매금액
                </LegendItem>
              </Legend>
            </ChartHeader>
            <ChartWrapper>
              {정읍Data && 대전Data && 보령Data && 여수Data ? (
                <Page3Barchart3
                  data={{
                    정읍Data: 정읍Data,
                    대전Data: 대전Data,
                    보령Data: 보령Data,
                    여수Data: 여수Data,
                  }}
                  height="100%"
                  width="100%"
                />
              ) : (
                <p>Loading...</p>
              )}
            </ChartWrapper>
          </Frame>
          <Frame>
            <ChartHeader>마을 간 거래 효과</ChartHeader>
            <ChartWrapper>
              {정읍Data && 대전Data && 보령Data && 여수Data ? (
                <Page3Barchart4
                  data={{
                    정읍Data: 정읍Data,
                    대전Data: 대전Data,
                    보령Data: 보령Data,
                    여수Data: 여수Data,
                  }}
                  height="100%"
                  width="100%"
                />
              ) : (
                <p>Loading...</p>
              )}
            </ChartWrapper>
            <BottomLegend>
              <Legend>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7.5"
                      r="5"
                      stroke="#FCB251"
                      stroke-width="4"
                    />
                  </svg>
                  거래전 판매/구매 금액
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7.5"
                      r="5"
                      stroke="#4282EF"
                      stroke-width="4"
                    />
                  </svg>
                  거래후 판매금액
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7.5"
                      r="5"
                      stroke="#B89EFA"
                      stroke-width="4"
                    />
                  </svg>
                  거래후 구매금액
                </LegendItem>
                <LegendItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <circle
                      cx="7"
                      cy="7.5"
                      r="5"
                      stroke="#94D474"
                      stroke-width="4"
                    />
                  </svg>
                  마을간 거래 효과
                </LegendItem>
              </Legend>
            </BottomLegend>
          </Frame>
        </Grid2>
      </Content>
      <PageArrowWrapper></PageArrowWrapper>
    </Wrapper>
  )
}

export default Page3
